import { WinningType } from "../../models/enum/winningType";
import { useTranslation } from "react-i18next";
import { FormEvent } from "react";
import { twclsx } from "../../utils/cssUtil";
import { Button } from "../common/button";

export function CheckedInSearchForm({
  onSearch,
  loading = false,
}: {
  onSearch: (type: WinningType, searchValue: string) => void;
  loading: boolean;
}) {
  const { t } = useTranslation();

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = Object.fromEntries(new FormData(e.currentTarget));
    const searchValue = formData.searchValue.toString();
    const winnerType =
      WinningType[formData.winnerType as keyof typeof WinningType];

    if (searchValue) {
      onSearch(winnerType, searchValue);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <div className={"p-3 flex justify-between gap-2"}>
        <select name={"winnerType"} className={"select select-bordered"}>
          <option key={WinningType.REGULAR} value={WinningType.REGULAR}>
            {t("eventdetail_checkincount_regular")}
          </option>
          <option key={WinningType.SPARE} value={WinningType.SPARE}>
            {t("eventdetail_checkincount_standby")}
          </option>
          <option key={WinningType.TARDY} value={WinningType.TARDY}>
            {t("userdetail_note_late")}
          </option>
        </select>
        <input
          name={"searchValue"}
          className={"input input-bordered w-full flex-1"}
          placeholder={t("checkinlist_placeholder")}
        ></input>
        <Button type={"submit"} className={"btn-primary"}>
          {loading ? (
            <span className={"loading loading-spinner"} />
          ) : (
            t("checkinlist_viewbutton")
          )}
        </Button>
      </div>
    </form>
  );
}
